<template>
  <main>
    <header>
      <h2 id="logo">
        Paul Jobard <span v-html="h2.job"></span> +
        <span v-html="h2.feat"></span> = <span v-html="h2.name"></span>&nbsp;
        <transition name="fade">
          <span v-html="h2.descr" v-if="!hasScrolled"></span>
        </transition>
      </h2>
      <router-link
        to="/"
        id="leave"
        v-on:mouseover.native="leave = true"
        v-on:mouseleave.native="mouseleaveBack"
      >
        <transition name="fade">
          <span v-if="leave">Retour</span>
        </transition>
      </router-link>
    </header>
    <div class="title">
      <h1 v-bind:style="styleH1" ref="h1" v-html="h1"></h1>
    </div>
    <div class="views" ref="view">
      <section v-bind:style="marginIntro">
        <p v-html="intro"></p>
      </section>
      <article v-bind:style="color">
        <img
          v-for="img in imgs"
          v-bind:key="img.index"
          v-bind:src="require('../assets/' + img.name + '.' + img.ext + '')"
        />
        <video v-if="video" controls>
          <source
            v-bind:src="require('../assets/' + video + '.mp4')"
            type="video/mp4"
          />
        </video>
      </article>
      <section v-bind:style="marginOutro">
        <p v-html="outro"></p>
      </section>
    </div>
    <transition name="next">
      <router-link class="next" v-if="next" v-bind:to="nextToPath">{{
        nextToName
      }}</router-link>
    </transition>
    <div class="bgColor"></div>
  </main>
</template>
<script>
export default {
  props: {
    h1: { type: String },
    h2: {
      job: { type: String },
      feat: { type: String },
      name: { type: String },
      descr: { type: String }
    },
    color: { type: Object },
    intro: { type: String },
    imgs: { type: Object },
    video: { type: String },
    outro: { type: String },
    nextToPath: { type: String },
    nextToName: { type: String }
  },
  data() {
    return {
      hasScrolled: false,
      leave: true,
      marginIntro: {
        marginTop: "0px",
        marginBottom: "0px"
      },
      // articleColor:{
      // 	backgroundColor : this.$props.color
      // },
      // imgSrc : require('../assets/' + this.$props.imgs[0] + '.png'),
      marginOutro: {
        marginTop: "0px",
        marginBottom: "0px"
      },
      styleH1: {
        transform: "translateX(0px)",
        opacity: "1"
      },
      // nextTo : '/'+this.$props.nextToPath,
      next: false
    };
  },
  methods: {
    handleScroll() {
      var ph = this.$refs.view.offsetHeight - window.innerHeight;
      var s = window.scrollY;

      if (s == 0) {
        this.$data.hasScrolled = false;
        this.$data.leave = true;
      } else if (Math.round(s) >= ph) {
        this.$data.next = true;
        this.$data.hasScrolled = true;
      } else {
        this.$data.next = false;
        this.$data.hasScrolled = true;
        this.$data.leave = false;
      }

      var v = window.innerHeight;
      var mini = v / 2 - 170;
      var maxi = ph - v / 2 + 170;
      var odef = 0.1;

      if (s < mini) {
        var pmin = Math.round((s * 100) / mini);
        var omin = Math.abs(pmin - 100) / 100;
        this.$data.styleH1.opacity = "" + Math.max(odef, omin) + "";
      }
      if (s >= mini && s <= maxi) {
        this.$data.styleH1.opacity = "" + odef + "";
      }
      if (s > maxi) {
        var pmax = Math.round(((s - maxi) * 100) / (ph - maxi));
        var omax = pmax / 100;
        this.$data.styleH1.opacity = "" + Math.max(odef, omax) + "";
      }
    },
    handleMousemove(e) {
      var x = e.clientX;
      var w = this.$refs.view.offsetWidth;
      var titleW = this.$refs.h1.offsetWidth;
      var p = Math.round((x * 100) / w) / 100;
      var t = p * (titleW - w);

      this.$data.styleH1.transform = "translateX(-" + t + "px)";
    },
    handleResize() {
      this.$data.marginIntro.marginTop = (window.innerHeight / 4) * 3 + "px";
      this.$data.marginIntro.marginBottom = window.innerHeight / 2 + "px";
      this.$data.marginOutro.marginTop = window.innerHeight / 2 + "px";
      this.$data.marginOutro.marginBottom = (window.innerHeight / 4) * 3 + "px";
    },
    mouseleaveBack() {
      if (this.$data.hasScrolled) {
        this.$data.leave = false;
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("mousemove", this.handleMousemove);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("mousemove", this.handleMousemove);
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
